function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "uploadAudio_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 722",
  transform: "translate(77 727)",
  fill: "#fff",
  stroke: "#707070",
  opacity: 0.539,
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-77 -727)",
  clipPath: "url(#uploadAudio_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 673",
  d: "M89 741a2.987 2.987 0 002.99-3l.01-6a3 3 0 00-6 0v6a3 3 0 003 3zm5.3-3a5.189 5.189 0 01-5.3 5.1 5.189 5.189 0 01-5.3-5.1H82a6.984 6.984 0 006 6.72V748h2v-3.28a6.968 6.968 0 006-6.72z",
  fill: "#024ccb"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 674",
  d: "M77 727h24v24H77z",
  fill: "none"
}));

function SvgUploadAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgUploadAudio;